export const TITLE = 'Mock Form with Prefill';
export const SUBTITLE = 'mock prefill testing (VA Form FORM_MOCK_PREFILL)';
